import { JSX } from "react";
import { ProductDownloadEntry } from "../../../../utils/productDetail/buildProductDownloadEntries";
import { ProductDownloadLink } from "./ProductDownloadLink";

interface Props {
    entry: ProductDownloadEntry;
}

export const ProductDownloadEntryItem = ({ entry }: Props): JSX.Element => (
    <div className="c-product-specs__item c-product-specs__item--downloads">
        <div className="item-text-header">{entry.label}</div>
        <div className="item-text-beverages c-product-downloads__list">
            {entry.files.map((file, index) => (
                <ProductDownloadLink
                    key={`${entry.key}-${index}`}
                    file={file}
                />
            ))}
        </div>
    </div>
);
